// auth.config.ts

import NextAuth, { type NextAuthConfig } from 'next-auth';
import Credentials from 'next-auth/providers/credentials';
import { fetchAuthMe } from './lib/server/api/auth';
import { getCookie } from './lib/helpers/userCookies';
import { loginSchema } from './types/auth';

const SESSION_MAX_AGE = Number(process.env.AUTH_SESSION_MAX_AGE ?? 60); // seconds

export const authConfig: NextAuthConfig = {
  trustHost: true,
  session: {
    strategy: 'jwt',
    maxAge: SESSION_MAX_AGE,
    updateAge: 0,
  },
  providers: [
    Credentials({
      async authorize() {
        try {
          const res = await fetchAuthMe();
          if (!res.ok) {
            // credenciales inválidas / token roto -> no hay usuario
            return null;
          }

          const me = res.data; // UserMeSchema

          return {
            email: me.email,
            name: me.name ?? me.email,
            role: me.role ?? 'Super Admin',
          };
        } catch {
          return null;
        }
      },
    }),
  ],
  callbacks: {
    async jwt({ token }) {
      const apiToken = await getCookie('api_access_token');
      token.externalAuthValid = Boolean(apiToken);

      const now = Math.floor(Date.now() / 1000);
      const t = token;
      if (!t.expiresAt) {
        t.expiresAt = now + SESSION_MAX_AGE;
      } else if (now >= t.expiresAt) {
        t.externalAuthValid = false;
      }

      return token;
    },

    async session({ session, token }) {
      const t = token;
      const now = Math.floor(Date.now() / 1000);
      const expired = !t.expiresAt || now >= t.expiresAt;

      if (expired || !t.externalAuthValid) {
        return null as unknown as import('next-auth').Session;
      }
      return session;
    },

    async redirect({ baseUrl }) {
      return `${baseUrl}/cameras`;
    },
  },
  pages: { signIn: '/auth/sign-in' },
};

export const { signIn, signOut, auth, handlers } = NextAuth(authConfig);
export { loginSchema };
